var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container list-header-operate"},[_c('div',{staticClass:"logo logo-white"})])
}]

export { render, staticRenderFns }